<template>
  <v-dialog v-model="overtimeDialog" width="90%" @click:outside="closeOvertime">
    <template v-slot:activator="{ on, attrs }">
      <p
        id="overtimeSummaryDialog"
        v-bind="attrs"
        v-on="on"
        @click="openDialog"
      ></p>
    </template>
    <v-card
      style="padding: 10px 20px 20px 20px; position: relative"
      class="text-center"
    >
      <v-row>
        <v-col md="12" style="padding: 0">
          <v-card-title>
            <v-spacer> </v-spacer>LIST PENGAJUAN LEMBUR<v-spacer> </v-spacer>
            <v-btn
              small
              icon
              color="red"
              style="color: white; position: absolute; top: 5px; right: 5px"
              @click="closeDialog"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            mobile-breakpoint="0"
            fixed-header
            height="50vh"
            @click:row="openOvertimeDetail"
            :headers="overtimeHeaders"
            style="cursor: pointer"
            :items="overtimeSummary"
            item-key="id"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
            }"
          >
            <template v-slot:[`item.request_no`]="{ item }">
              <div
                :style="`width:120px; font-size:12px; padding: 0; display: flex; flex-direction: row; justify-content: start; align-items:center;`"
              >
                {{ item.request_no }}
              </div>
            </template>
            <template v-slot:[`item.total_hour`]="{ item }">
              <div
                style="
                  width: 70px;
                  font-size: 14px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                  justify-content: start;
                  align-items: center;
                "
              >
                {{ item.total_hour + ' ' }}jam
              </div>
            </template>
            <template v-slot:[`item.total_hour_rounding`]="{ item }">
              <div
                style="
                  width: 70px;
                  font-size: 14px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                  justify-content: start;
                  align-items: center;
                "
              >
                {{ item.total_hour_rounding + ' ' }}jam
              </div>
            </template>
            <template v-slot:[`item.request_start_time`]="{ item }">
              <div
                style="
                  width: 150px;
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ convertDateTime(item.request_start_time) }}
              </div>
            </template>
            <template v-slot:[`item.request_end_time`]="{ item }">
              <div
                style="
                  width: 150px;
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ convertDateTime(item.request_end_time) }}
              </div>
            </template>
            <template v-slot:[`item.status_request`]="{ item }">
              <div
                :style="`text-transform:uppercase; font-size:12px; font-weight:bolder; padding: 0; display: flex; flex-direction: row; color:${statusColor(
                  item.status_request
                )};`"
              >
                {{ statusName(item.status_request) }}
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OvertimeList',
  props: ['overtimeSummary'],
  data() {
    return {
      overtimeDialog: false,
      isLoading: false,
      overtimeResult: []
    }
  },
  computed: {
    overtimeHeaders() {
      return [
        {
          text: 'No. Pengajuan',
          value: 'request_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Waktu mulai',
          value: 'request_start_time',
          sortable: false
        },
        {
          text: 'Waktu berakhir',
          value: 'request_end_time',
          sortable: false
        },
        {
          text: 'Total waktu lembur',
          value: 'total_hour',
          sortable: false
        },
        {
          text: 'Pembulatan',
          value: 'total_hour_rounding',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status_request',
          sortable: false
        }
      ]
    }
  },
  methods: {
    openDialog() {
      console.log(this.overtimeSummary)
    },
    closeDialog() {
      this.overtimeDialog = false
    },

    statusName(val) {
      switch (val) {
        case -2:
          return 'CANCELED'
        case -1:
          return 'REJECTED'
        case 0:
          return 'DRAFT'
        case 1:
          return 'WAITING APPROVAL'
        case 2:
          return 'APPROVED'
        default:
          break
      }
    },
    statusColor(val) {
      switch (val) {
        case -2:
          return 'red'
        case -1:
          return 'red'
        case 0:
          return 'blue'
        case 1:
          return 'orange'
        case 2:
          return 'green'
        default:
          break
      }
    },
    convertDateTime(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    closeOvertime() {
      this.overtimeDialog = false
    },
    openOvertimeDetail(item) {
      setTimeout(() => {
        window.open(`/hr/overtime/detail/${item.id}`, '_blank')
      }, 100)
    }
  }
}
</script>

<style></style>
